'use client';

import { useCallback, useRef } from 'react';
import { useStore } from '@/store/store';
import { ErrorPopup } from '@/app/components/site-wide-jackpot/subcomponents/error-popup/error-popup';
import type { SupportLink } from '@/logic/page-config/footer/footer-links';

const FADE_OUT_DURATION = 300;

type SWJErrorPopUpProps = {
    params: Record<string, unknown>;
};

export const SWJErrorPopUp: React.FC<SWJErrorPopUpProps> = ({ params }) => {
    const { closePopup } = useStore((s) => s.popup);
    const containerRef = useRef<HTMLDivElement>(null);

    const handleClose = useCallback(() => {
        const popupElement = containerRef.current?.closest('.popup');
        if (popupElement) {
            popupElement.classList.add('fade-out');
            setTimeout(closePopup, FADE_OUT_DURATION);
        } else {
            closePopup();
        }
    }, [closePopup]);

    if (!params?.errorCode) {
        return null;
    }

    return (
        <div ref={containerRef}>
            <ErrorPopup
                onClose={handleClose}
                errorCode={params.errorCode as string}
                support={params.support as SupportLink | undefined}
                multiplier={params.multiplier as number | undefined}
            />
        </div>
    );
};
